// global
import React, { Component } from 'react';
import { Popup, List, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//local
import { openUpdate, TYPE } from 'app/redux/actions/modal';
import { STATUS } from 'salvus-shared/consts/patient';
import { openModal as openInitModal } from 'app/redux/actions/patient/enableModal';
import { openModal as openDeinitModal } from 'app/redux/actions/patient/disableModal';
import { TYPE as CLIENT_TYPE } from 'salvus-shared/consts/client';
import { PROFILE } from 'salvus-shared/consts/account';
//style
import './PopupPatient.scss';

class PopupPatient extends Component {
    constructor(props) {
        super(props);
        this.state = { opened: false };
    }

    onClickEdit = patient => () => {
        this.handleClose();
        this.props.dispatch(openUpdate(TYPE.PATIENT, patient));
    };

    onClickInit = patient => () => {
        this.handleClose();
        this.props.dispatch(openInitModal(patient));
    };

    onClickDeinit = patient => () => {
        this.handleClose();
        this.props.dispatch(openDeinitModal(patient));
    };

    handleOpen = () => this.setState({ opened: true });

    handleClose = () => this.setState({ opened: false });

    handleClickTrigger = e => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ opened: true });
    };

    render() {
        const { auth, row } = this.props;
        const { opened } = this.state;
        const trigger = <Button circular icon="ellipsis vertical" className="trigget-popup-patient" onClick={this.handleClickTrigger} />;
        const initializedPatient = row.status === STATUS.INITIALIZED;
        const deactivatedPatient = row.status === STATUS.DEACTIVATED;
        const content = (
            <List className="patient-popup">
                {!(auth.account.client.type === CLIENT_TYPE.SALVUS && auth.account.profile === PROFILE.DEFAULT) && (
                    <List.Item>
                        <Button className={!initializedPatient ? '' : 'btn-highlighted'} onClick={this.onClickEdit(row)}>
                            Editar
                        </Button>
                    </List.Item>
                )}
                {!initializedPatient && (
                    <List.Item>
                        <Button className="btn-highlighted" onClick={this.onClickInit(row)}>
                            {deactivatedPatient ? 'Reativar' : 'Iniciar'}
                        </Button>
                    </List.Item>
                )}
                {initializedPatient && (
                    <List.Item>
                        <Button onClick={this.onClickDeinit(row)}>Desativar</Button>
                    </List.Item>
                )}
            </List>
        );
        return (
            <Popup
                open={opened}
                onOpen={this.handleOpen}
                onClose={this.handleClose}
                trigger={trigger}
                content={content}
                position="bottom center"
                on="click"
                hideOnScroll
            />
        );
    }
}

PopupPatient.propTypes = {
    auth: PropTypes.object,
    row: PropTypes.object,
    dispatch: PropTypes.func,
    allPatients: PropTypes.array,
};

const mapStateToProps = state => ({
    auth: state.auth,
    patient: state.patient,
    data: state.data,
});
export default connect(mapStateToProps)(PopupPatient);
